import { lists } from "@/stock/constants/tables";

export const useOrderFilter = {
  data() {
    return {
      order: "desc",
      orderColumn: 'Создан',
      orderFields: lists.stockEntity.orderFields,
    };
  },
  computed: {
    orderIconCss() {
      const arrowDirection = this.order === "desc" ? "down" : "up";
      return ['fa', `fa-arrow-${arrowDirection}`];
    },
  },
  methods: {
    addOrderQueryParam(url) {
      const orderField = this.orderFields[this.orderColumn];
      url += `&order=${orderField},${this.order}`;
      return url;
    },
    toggleOrder(columnName = '') {
      if (this.orderColumn !== columnName) {
        this.orderColumn = columnName;
        return;
      }
      const nextState = this.order === "desc" ? "asc" : "desc";
      this.order = nextState;
    },
    resetOrder() {
      this.orderColumn = 'Создан';
      this.order = 'desc';
    },
    isOrderColumn(name) {
      return !!(this.orderFields[name]);
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useOrderFilter.js